import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class VatCategoryValueObject  {
    _originalTypeClassName = "zERP.BO.VatCategoryValueObject";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
VatCategoryValueObject.translate = translateService;
}
this.Id = null;
this.Name = null;
this.Description = null;
this.Code = null;
this.Rate = null;
this.NonDeductible = false;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Name:any;
Description:any;
Code:any;
Rate:any;
NonDeductible:any;
AccountingConfig:any;
ExpenseBudgetItem:any;
static setAccountingConfig = ($this, value) => {
var oldValue = $this.AccountingConfig;
$this.AccountingConfig = value;
if (value != null) {
}
}
static setExpenseBudgetItem = ($this, value) => {
var oldValue = $this.ExpenseBudgetItem;
$this.ExpenseBudgetItem = value;
if (value != null) {
}
}

static GetClassName(): any{return CLMS.Framework.Utilities.ThrowException("StdLib.RuntimeType.Name()").Test;
}
static GetRate($this: any): any{switch ($this?.Code) {case 1:
{
return 0.24;}
case 2:
{
return 0.13;}
case 3:
{
return 0.06;}
case 4:
{
return 0.17;}
case 5:
{
return 0.09;}
case 6:
{
return 0.04;}
case 7:
{
return 0.0;}
case 8:
{
return 0.0;}
default:
{
return $this?.Rate;}
}
return $this?.Rate;
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}